import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { ShippingGatewayProvider } from '../ShippingGatewayProvider'

@InputType()
export class GetShippingLabelArgs extends ActionArgs {
  @Field(() => String)
  labelId: string

  @Field(() => String)
  labelType: 'pdf' | 'png' | 'zpl' | 'href'

  @Field(() => String)
  labelValue: string

  @Field(() => String)
  gatewayProvider: ShippingGatewayProvider
}

export interface IGetShippingLabel extends IAction<string, GetShippingLabelArgs> {}
